export const global = {
  state: {
    date: ''
  },
  actions: {
    saveDate ({ commit }, date) {
      commit('setDate', date);
    }
  },
  mutations: {
    setDate (state, date) {
      state.date = date;
    },
  },
  getters: {
    getDate (state) {
      return state.date;
    }
  }
};

export default global;
